module.exports = __webpack_public_path__ + "img/inconclusive-logo.f3468c8a.svg";